<template>
    <div>
        <div>
            <h4 class="p-2 mb-0">Monitor de cargos y abonos</h4>
            <vs-row class="mt-4">
                <!-- <vs-col sm="12" lg="3">
                    <form autocomplete="off">
                        <label for="grupo" class="labelInput">
                            Tipo
                        </label>
                        <vs-select class="pt-0" filter placeholder="Seleccionar tipo" :key="programaId" v-model="tipo">
                            <template #message-danger v-if="errorFields.includes('tipo')">
                                Requerido
                            </template>
                            <vs-option label="Global" value="global">
                                Global
                            </vs-option>
                            <vs-option label="A detalle" value="detalle">
                                A detalle
                            </vs-option>
                        </vs-select>
                    </form>
                </vs-col> -->
                <vs-col sm="12" lg="3">
                    <form autocomplete="off">
                        <label for="grupo" class="labelInput">
                            Institución
                        </label>
                        <vs-select class="pt-0"  filter placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" :disabled="!instituciones.length">
                            <template #message-danger v-if="errorFields.includes('institucion')">
                                Requerido
                            </template>
                            <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="3">
                    <div class="d-flex " style="justify-content: space-between;">
                        <label for="grupo" class="labelInput">
                            Ciclo escolar
                        </label>
                        <div class="d-flex" v-if="cicloEscolares[0]">
                            <div> 
                                <vs-tooltip>
                                    <i class="fas fa-check-square" style="cursor:pointer" @click="selectAll(cicloEscolares, 'cicloEscolares')"></i>
                                    <template #tooltip>
                                        Seleccionar todo
                                    </template>
                                </vs-tooltip>
                            </div>
                            <div class="labelInput">
                                <vs-tooltip>
                                    <i class="far fa-times-circle" style="cursor:pointer" @click="deseleccionarAll('cicloEscolares')"></i>
                                    <template #tooltip>
                                        Deseleccionar todo
                                    </template>
                                </vs-tooltip>
                            </div>
                            
                        </div>
                    </div>
                    <vs-select class="pt-0" multiple collapse-chips filter :loading="loadingCicloEscolar" placeholder="Seleccionar Ciclo Escolar" :key="cicloEscolarId" v-model="cicloEscolar" :disabled="!cicloEscolares.length">
                        <template #message-danger v-if="errorFields.includes('cicloEscolar')">
                            Requerido
                        </template>
                        <vs-option v-for="(option, index) in cicloEscolares" :key="index"  :label="option.text" :value="option.id">
                            {{option.text}}
                        </vs-option>
                    </vs-select>
                </vs-col>
                <vs-col sm="12" lg="3" style="display: flex !important; flex-direction: row-reverse;">
                    <vs-button
                        @click="getBecasDescuentos('online')"
                        class="mb-2"
                        type="submit"
                    >
                        <i class="fas fa-search mr-2"></i> Buscar
                    </vs-button>
                </vs-col>
            </vs-row>
        </div>
        <h4 v-if="!tipo" class="text-center mt-3">Sin información</h4>
        <div v-else>
            <vs-button
                v-if="detalle.length"
                class="ml-auto"
                success
                flat
                @click="activeCompartir =! activeCompartir"
            >
                <i class="far fa-copy mr-2"></i> Compartir información
            </vs-button>
            <tabla-global v-if="tipo == 'global'" :global="global"></tabla-global>
            <tabla-detalle v-if="tipo == 'detalle'" :detalle="detalle" :cicloEscolar="cicloEscolar" :cicloEscolares="cicloEscolares" @filtros="getProgramasCicloSeleccionado" @filtrosVacios="getFiltrosAlumnos" @filtrosModificados="getFiltrosModificados" :filtrosGenerales="filtrosGenerales" ></tabla-detalle>
            <compartir-informacion v-model="activeCompartir" @enviarInfo="getClipboard"></compartir-informacion>
        </div>
    </div>
</template>

<script>
import general from '../../../../api/requests/general'
import indicadores from '../../../../api/requests/indicadores'
import TablaGlobal from './global.vue'
import TablaDetalle from './detalle.vue'
import CompartirInformacion from './detalle/modal-compartir.vue'
export default {
    data(){
        return{
            institucion:'',
            instituciones: [],
            institucionId: (new Date()).getTime(),
            loadingInstituto: false,
            cicloEscolar:[],
            cicloEscolares: [],
            cicloEscolarId: (new Date()).getTime(),
            loadingCicloEscolar: false,
            programa: [],
            programas: [],
            programaId: (new Date()).getTime(),
            loadingPrograma: false,
            tipo: 'detalle',
            errorFields: [],
            global: [],
            detalle: [],
            loadingExcel: false,
            con_beca: '',
            con_pago_inscripcion : '',
            filtros: false,
            filtrosGenerales: {},
            filtrosLink: {},
            activeCompartir: false
        }
    },
    components:{
        TablaGlobal,
        TablaDetalle,
        CompartirInformacion
    },
    created(){
        this.getInstituciones()
        this.getFiltrosUrl()
    },
    methods: {
        getFiltrosUrl(){
            let params = (new URL(document.location)).searchParams;
            const ruta_url = params.get('f');
            if(ruta_url){
                const filtro = atob(ruta_url)
                this.filtrosGenerales = JSON.parse(filtro)
                this.institucion = this.filtrosGenerales.institucion
                this.cicloEscolar = this.filtrosGenerales.cicloEscolar
                this.tipo = this.filtrosGenerales.tipo
                this.getBecasDescuentos('online')
            }
        },
        getProgramasCicloSeleccionado(sele){
            this.filtrosGenerales.cicloSeleccionado = sele.cicloSeleccionado
            this.filtrosGenerales.programaSeleccionado = sele.programaSeleccionado
        },
        getCompartirInfo(filtros){
            if(!this.filtrosGenerales.tipo && this.detalle){
                this.filtrosGenerales = {
                    "tipo": this.tipo,
                    "institucion": this.institucion,
                    "cicloEscolar": this.cicloEscolar,
                    "cicloSeleccionado": this.detalle[0]?.ciclo_escolar,
                    "programaSeleccionado": this.detalle[0]?.programas[0]?.programa,
                }
                const alumnosFiltro = []
                this.detalle.forEach(i =>{
                    const obj = {ciclo_escolar: i.ciclo_escolar_id, programas: []}
                    i.programas.forEach(j => {
                        obj.programas.push({programa: j.programa_id, filtros: [], filtro_texto: ''})
                    })
                    alumnosFiltro.push(obj)
                })
                this.filtrosGenerales.alumnosFiltro = alumnosFiltro
            }
        },
        getFiltrosAlumnos(obj){
            this.filtrosGenerales.alumnosFiltro[obj.ciclo].programas[obj.programa].filtros = obj.filtros
            this.filtrosGenerales.alumnosFiltro[obj.ciclo].programas[obj.programa].filtro_texto = obj.filtro_texto
        },
        getFiltrosModificados(obj){
            this.filtrosGenerales.cicloSeleccionado = this.detalle[obj.ciclo]?.ciclo_escolar
            this.filtrosGenerales.programaSeleccionado = this.detalle[obj.ciclo]?.programas[obj.programa]?.programa
            this.filtrosGenerales.alumnosFiltro[obj.ciclo].programas[obj.programa].filtros = obj.filtros
            this.filtrosGenerales.alumnosFiltro[obj.ciclo].programas[obj.programa].filtro_texto = obj.filtro_texto
        },
        getClipboard(){
            const url = location.hostname 
            const encode = JSON.stringify(this.filtrosGenerales)
            const ruta = url + ':8000/reportes/monitor-cargos-abonos?f=' + btoa(encode)
            
            navigator.clipboard.writeText(ruta);
        },
        selectAll(seleccion, tipo){
            let arr = []
            seleccion.forEach(i => {
            arr.push(i.id)
            })
            if(tipo == 'programas'){
                this.programa = arr
            }
            if(tipo == 'cicloEscolares'){
                this.cicloEscolar = arr
            }
        },
        deseleccionarAll(tipo){
            if(tipo == 'programas'){
                this.programa = []
            }
            if(tipo == 'cicloEscolares'){
                this.cicloEscolar = []
            }
        },
        sanityForm () {
            this.errorFields = []
            if (!this.institucion) {
                this.errorFields.push('institucion')
            }
            if (!this.cicloEscolar) {
                this.errorFields.push('cicloEscolar')
            }
            if (!this.tipo) {
                this.errorFields.push('tipo')
            }
            if (!this.errorFields.length){
                return true
            } else {
                return null
            }
        },
        async getBecasDescuentos(info){
            if(this.sanityForm()){
                const params = {
                    institucion_id: this.institucion,
                    type_response: info
                }
                if(this.cicloEscolar){
                    params.ciclo_escolar_id = this.cicloEscolar.filter(detalle => ![null, NaN, ''].includes(detalle))
                }else{
                    params.ciclo_escolar_id = this.cicloEscolar
                }
                if(this.tipo == 'detalle'){
                    if(info == 'online'){
                    this.global = []
                    const loading = this.$vs.loading()
                    const {data: response} = await indicadores.getBecasDescuentosDetalle(params)
                    this.detalle = this.getEliminarNameKey(response)
            //         this.detalle =  [
            //     {
            //         "ciclo_escolar": "1 2020 julio-diciembre",
            //         "ciclo_escolar_id": 4,
            //         "programas": [
            //             {
            //                 "programa": "Preparatoria Plan 97_ UNAM DGIRE",
            //                 "programa_id": 1,
            //                 "alumnos":[
            //                     {
            //                         "persona_id": 42197,
            //                         "matricula": "DRES421941",
            //                         "nombre": "DIEGO REBOULEN ESTEBAN con beca",
            //                         "grado": "Grado (Año) 1",
            //                         "beca_nombre": "Sin beca",
            //                         "beca_porcentaje": "Sin beca",
            //                         "beca_alcance": "Sin beca",
            //                         "cuenta_con_pago_inscripcion":true,
            //                         "cuenta_con_beca":true,
            //                         "cargos": [
            //                         {
            //                             "monto": 20350,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "cargo",
            //                             "codigo_detalle": "INSCRIPCIÓN",
            //                             "categoria": "inscripcion",
            //                             "fecha_vigencia_aplicacion": "2022-08-12"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "cargo",
            //                             "codigo_detalle": "COLEGIATURA AGOSTO",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-08-31"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "cargo",
            //                             "codigo_detalle": "COLEGIATURA SEPTIEMBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-09-12"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "cargo",
            //                             "codigo_detalle": "COLEGIATURA OCTUBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-10-12"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "cargo",
            //                             "codigo_detalle": "COLEGIATURA NOVIEMBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-11-14"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "cargo",
            //                             "codigo_detalle": "COLEGIATURA DICIEMBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-12-13"
            //                         }
            //                         ],
            //                         "pagos": [
            //                         {
            //                             "monto": 7000,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO DE INSCRIPCIÓN",
            //                             "categoria": "inscripcion",
            //                             "fecha_vigencia_aplicacion": "2022-06-24"
            //                         },
            //                         {
            //                             "monto": 6330,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO DE INSCRIPCIÓN",
            //                             "categoria": "inscripcion",
            //                             "fecha_vigencia_aplicacion": "2022-07-01"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO COLEGIATURA SEPTIEMBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-10-05"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO COLEGIATURA AGOSTO",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-10-05"
            //                         },
            //                         {
            //                             "monto": 8080,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO COLEGIATURA OCTUBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-10-12"
            //                         },
            //                         {
            //                             "monto": 8080,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO COLEGIATURA NOVIEMBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-11-11"
            //                         },
            //                         {
            //                             "monto": 8080,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO COLEGIATURA DICIEMBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-12-08"
            //                         }
            //                         ],
            //                         "becas": [],
            //                         "descuentos": [
            //                         {
            //                             "monto": 1020,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "DESCUENTO INSCRIPCIÓN",
            //                             "categoria": "rebaja",
            //                             "fecha_vigencia_aplicacion": "2022-07-01"
            //                         },
            //                         {
            //                             "monto": 520,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "DESCUENTO OCTUBRE",
            //                             "categoria": "rebaja",
            //                             "fecha_vigencia_aplicacion": "2022-10-12"
            //                         },
            //                         {
            //                             "monto": 520,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "DESCUENTO NOVIEMBRE",
            //                             "categoria": "rebaja",
            //                             "fecha_vigencia_aplicacion": "2022-11-11"
            //                         },
            //                         {
            //                             "monto": 520,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "DESCUENTO DICIEMBRE",
            //                             "categoria": "rebaja",
            //                             "fecha_vigencia_aplicacion": "2022-12-08"
            //                         }
            //                         ]
            //                     },
            //                     {
            //                         "persona_id": 42197,
            //                         "matricula": "DRES42194",
            //                         "nombre": "DIEGO REBOULEN ESTEBAN",
            //                         "grado": "Grado (Año) 1",
            //                         "beca_nombre": "Sin beca",
            //                         "beca_porcentaje": "Sin beca",
            //                         "beca_alcance": "Sin beca",
            //                         "cuenta_con_pago_inscripcion":false,
            //                         "cuenta_con_beca":false,
            //                         "cargos": [
            //                         {
            //                             "monto": 20350,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "cargo",
            //                             "codigo_detalle": "INSCRIPCIÓN",
            //                             "categoria": "inscripcion",
            //                             "fecha_vigencia_aplicacion": "2022-08-12"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "cargo",
            //                             "codigo_detalle": "COLEGIATURA AGOSTO",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-08-31"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "cargo",
            //                             "codigo_detalle": "COLEGIATURA SEPTIEMBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-09-12"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "cargo",
            //                             "codigo_detalle": "COLEGIATURA OCTUBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-10-12"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "cargo",
            //                             "codigo_detalle": "COLEGIATURA NOVIEMBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-11-14"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "cargo",
            //                             "codigo_detalle": "COLEGIATURA DICIEMBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-12-13"
            //                         }
            //                         ],
            //                         "pagos": [
            //                         {
            //                             "monto": 7000,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO DE INSCRIPCIÓN",
            //                             "categoria": "inscripcion",
            //                             "fecha_vigencia_aplicacion": "2022-06-24"
            //                         },
            //                         {
            //                             "monto": 6330,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO DE INSCRIPCIÓN",
            //                             "categoria": "inscripcion",
            //                             "fecha_vigencia_aplicacion": "2022-07-01"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO COLEGIATURA SEPTIEMBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-10-05"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO COLEGIATURA AGOSTO",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-10-05"
            //                         },
            //                         {
            //                             "monto": 8080,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO COLEGIATURA OCTUBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-10-12"
            //                         },
            //                         {
            //                             "monto": 8080,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO COLEGIATURA NOVIEMBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-11-11"
            //                         },
            //                         {
            //                             "monto": 8080,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO COLEGIATURA DICIEMBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-12-08"
            //                         }
            //                         ],
            //                         "becas": [],
            //                         "descuentos": [
            //                         {
            //                             "monto": 1020,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "DESCUENTO INSCRIPCIÓN",
            //                             "categoria": "rebaja",
            //                             "fecha_vigencia_aplicacion": "2022-07-01"
            //                         },
            //                         {
            //                             "monto": 520,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "DESCUENTO OCTUBRE",
            //                             "categoria": "rebaja",
            //                             "fecha_vigencia_aplicacion": "2022-10-12"
            //                         },
            //                         {
            //                             "monto": 520,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "DESCUENTO NOVIEMBRE",
            //                             "categoria": "rebaja",
            //                             "fecha_vigencia_aplicacion": "2022-11-11"
            //                         },
            //                         {
            //                             "monto": 520,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "DESCUENTO DICIEMBRE",
            //                             "categoria": "rebaja",
            //                             "fecha_vigencia_aplicacion": "2022-12-08"
            //                         }
            //                         ]
            //                     }
            //                 ]
            //             },
            //             {
            //                 "programa": "otro Preparatoria de la Universidad Marista de San Luis Potosí",
            //                 "programa_id": 2,
            //                 "alumnos": [
            //                     {
            //                         "persona_id": 42197,
            //                         "matricula": "DRES42194",
            //                         "nombre": "Juan Banana beca",
            //                         "grado": "Grado (Año) 1",
            //                         "beca_nombre": "Sin beca",
            //                         "beca_porcentaje": "Sin beca",
            //                         "beca_alcance": "Sin beca",
            //                         "cuenta_con_pago_inscripcion":false,
            //                         "cuenta_con_beca":true,
            //                         "cargos": [
            //                         {
            //                             "monto": 20350,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "cargo",
            //                             "codigo_detalle": "INSCRIPCIÓN",
            //                             "categoria": "inscripcion",
            //                             "fecha_vigencia_aplicacion": "2022-08-12"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "cargo",
            //                             "codigo_detalle": "COLEGIATURA AGOSTO",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-08-31"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "cargo",
            //                             "codigo_detalle": "COLEGIATURA SEPTIEMBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-09-12"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "cargo",
            //                             "codigo_detalle": "COLEGIATURA OCTUBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-10-12"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "cargo",
            //                             "codigo_detalle": "COLEGIATURA NOVIEMBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-11-14"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "cargo",
            //                             "codigo_detalle": "COLEGIATURA DICIEMBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-12-13"
            //                         }
            //                         ],
            //                         "pagos": [
            //                         {
            //                             "monto": 7000,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO DE INSCRIPCIÓN",
            //                             "categoria": "inscripcion",
            //                             "fecha_vigencia_aplicacion": "2022-06-24"
            //                         },
            //                         {
            //                             "monto": 6330,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO DE INSCRIPCIÓN",
            //                             "categoria": "inscripcion",
            //                             "fecha_vigencia_aplicacion": "2022-07-01"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO COLEGIATURA SEPTIEMBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-10-05"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO COLEGIATURA AGOSTO",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-10-05"
            //                         },
            //                         {
            //                             "monto": 8080,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO COLEGIATURA OCTUBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-10-12"
            //                         },
            //                         {
            //                             "monto": 8080,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO COLEGIATURA NOVIEMBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-11-11"
            //                         },
            //                         {
            //                             "monto": 8080,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO COLEGIATURA DICIEMBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-12-08"
            //                         }
            //                         ],
            //                         "becas": [],
            //                         "descuentos": [
            //                         {
            //                             "monto": 1020,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "DESCUENTO INSCRIPCIÓN",
            //                             "categoria": "rebaja",
            //                             "fecha_vigencia_aplicacion": "2022-07-01"
            //                         },
            //                         {
            //                             "monto": 520,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "DESCUENTO OCTUBRE",
            //                             "categoria": "rebaja",
            //                             "fecha_vigencia_aplicacion": "2022-10-12"
            //                         },
            //                         {
            //                             "monto": 520,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "DESCUENTO NOVIEMBRE",
            //                             "categoria": "rebaja",
            //                             "fecha_vigencia_aplicacion": "2022-11-11"
            //                         },
            //                         {
            //                             "monto": 520,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "DESCUENTO DICIEMBRE",
            //                             "categoria": "rebaja",
            //                             "fecha_vigencia_aplicacion": "2022-12-08"
            //                         }
            //                         ]
            //                     },]
            //             },
            //         ]
            //     },
            //     {
            //         "ciclo_escolar": "otro mas",
            //         "ciclo_escolar_id": 4,
            //         "programas": [
            //             {
            //                 "programa": "Preparatoria Plan 97_ UNAM DGIRE",
            //                 "programa_id": 3,
            //                 "alumnos":[
            //                     {
            //                         "persona_id": 42197,
            //                         "matricula": "DRES42194",
            //                         "nombre": "Bruno Diaz con beca",
            //                         "grado": "Grado (Año) 1",
            //                         "beca_nombre": "Sin beca",
            //                         "beca_porcentaje": "Sin beca",
            //                         "beca_alcance": "Sin beca",
            //                         "cuenta_con_pago_inscripcion":true,
            //                         "cuenta_con_beca":true,
            //                         "cargos": [
            //                         {
            //                             "monto": 20350,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "cargo",
            //                             "codigo_detalle": "INSCRIPCIÓN",
            //                             "categoria": "inscripcion",
            //                             "fecha_vigencia_aplicacion": "2022-08-12"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "cargo",
            //                             "codigo_detalle": "COLEGIATURA AGOSTO",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-08-31"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "cargo",
            //                             "codigo_detalle": "COLEGIATURA SEPTIEMBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-09-12"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "cargo",
            //                             "codigo_detalle": "COLEGIATURA OCTUBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-10-12"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "cargo",
            //                             "codigo_detalle": "COLEGIATURA NOVIEMBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-11-14"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "cargo",
            //                             "codigo_detalle": "COLEGIATURA DICIEMBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-12-13"
            //                         }
            //                         ],
            //                         "pagos": [
            //                         {
            //                             "monto": 7000,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO DE INSCRIPCIÓN",
            //                             "categoria": "inscripcion",
            //                             "fecha_vigencia_aplicacion": "2022-06-24"
            //                         },
            //                         {
            //                             "monto": 6330,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO DE INSCRIPCIÓN",
            //                             "categoria": "inscripcion",
            //                             "fecha_vigencia_aplicacion": "2022-07-01"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO COLEGIATURA SEPTIEMBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-10-05"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO COLEGIATURA AGOSTO",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-10-05"
            //                         },
            //                         {
            //                             "monto": 8080,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO COLEGIATURA OCTUBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-10-12"
            //                         },
            //                         {
            //                             "monto": 8080,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO COLEGIATURA NOVIEMBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-11-11"
            //                         },
            //                         {
            //                             "monto": 8080,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO COLEGIATURA DICIEMBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-12-08"
            //                         }
            //                         ],
            //                         "becas": [],
            //                         "descuentos": [
            //                         {
            //                             "monto": 1020,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "DESCUENTO INSCRIPCIÓN",
            //                             "categoria": "rebaja",
            //                             "fecha_vigencia_aplicacion": "2022-07-01"
            //                         },
            //                         {
            //                             "monto": 520,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "DESCUENTO OCTUBRE",
            //                             "categoria": "rebaja",
            //                             "fecha_vigencia_aplicacion": "2022-10-12"
            //                         },
            //                         {
            //                             "monto": 520,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "DESCUENTO NOVIEMBRE",
            //                             "categoria": "rebaja",
            //                             "fecha_vigencia_aplicacion": "2022-11-11"
            //                         },
            //                         {
            //                             "monto": 520,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "DESCUENTO DICIEMBRE",
            //                             "categoria": "rebaja",
            //                             "fecha_vigencia_aplicacion": "2022-12-08"
            //                         }
            //                         ]
            //                     },
            //                     {
            //                         "persona_id": 42197,
            //                         "matricula": "DRES42194",
            //                         "nombre": "DIEGO REBOULEN ESTEBAN",
            //                         "grado": "Grado (Año) 1",
            //                         "beca_nombre": "Sin beca",
            //                         "beca_porcentaje": "Sin beca",
            //                         "beca_alcance": "Sin beca",
            //                         "cuenta_con_pago_inscripcion":false,
            //                         "cuenta_con_beca":false,
            //                         "cargos": [
            //                         {
            //                             "monto": 20350,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "cargo",
            //                             "codigo_detalle": "INSCRIPCIÓN",
            //                             "categoria": "inscripcion",
            //                             "fecha_vigencia_aplicacion": "2022-08-12"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "cargo",
            //                             "codigo_detalle": "COLEGIATURA AGOSTO",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-08-31"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "cargo",
            //                             "codigo_detalle": "COLEGIATURA SEPTIEMBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-09-12"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "cargo",
            //                             "codigo_detalle": "COLEGIATURA OCTUBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-10-12"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "cargo",
            //                             "codigo_detalle": "COLEGIATURA NOVIEMBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-11-14"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "cargo",
            //                             "codigo_detalle": "COLEGIATURA DICIEMBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-12-13"
            //                         }
            //                         ],
            //                         "pagos": [
            //                         {
            //                             "monto": 7000,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO DE INSCRIPCIÓN",
            //                             "categoria": "inscripcion",
            //                             "fecha_vigencia_aplicacion": "2022-06-24"
            //                         },
            //                         {
            //                             "monto": 6330,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO DE INSCRIPCIÓN",
            //                             "categoria": "inscripcion",
            //                             "fecha_vigencia_aplicacion": "2022-07-01"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO COLEGIATURA SEPTIEMBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-10-05"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO COLEGIATURA AGOSTO",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-10-05"
            //                         },
            //                         {
            //                             "monto": 8080,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO COLEGIATURA OCTUBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-10-12"
            //                         },
            //                         {
            //                             "monto": 8080,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO COLEGIATURA NOVIEMBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-11-11"
            //                         },
            //                         {
            //                             "monto": 8080,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO COLEGIATURA DICIEMBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-12-08"
            //                         }
            //                         ],
            //                         "becas": [],
            //                         "descuentos": [
            //                         {
            //                             "monto": 1020,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "DESCUENTO INSCRIPCIÓN",
            //                             "categoria": "rebaja",
            //                             "fecha_vigencia_aplicacion": "2022-07-01"
            //                         },
            //                         {
            //                             "monto": 520,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "DESCUENTO OCTUBRE",
            //                             "categoria": "rebaja",
            //                             "fecha_vigencia_aplicacion": "2022-10-12"
            //                         },
            //                         {
            //                             "monto": 520,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "DESCUENTO NOVIEMBRE",
            //                             "categoria": "rebaja",
            //                             "fecha_vigencia_aplicacion": "2022-11-11"
            //                         },
            //                         {
            //                             "monto": 520,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "DESCUENTO DICIEMBRE",
            //                             "categoria": "rebaja",
            //                             "fecha_vigencia_aplicacion": "2022-12-08"
            //                         }
            //                         ]
            //                     }
            //                 ]
            //             },
            //             {
            //                 "programa": "Preparatoria de la Universidad Marista de San Luis Potosí",
            //                 "programa_id": 4,
            //                 "alumnos": [
            //                     {
            //                         "persona_id": 42197,
            //                         "matricula": "DRES42194",
            //                         "nombre": "Porfirio Diaz",
            //                         "grado": "Grado (Año) 1",
            //                         "beca_nombre": "Sin beca",
            //                         "beca_porcentaje": "Sin beca",
            //                         "beca_alcance": "Sin beca",
            //                         "cuenta_con_pago_inscripcion":false,
            //                         "cuenta_con_beca":true,
            //                         "cargos": [
            //                         {
            //                             "monto": 20350,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "cargo",
            //                             "codigo_detalle": "INSCRIPCIÓN",
            //                             "categoria": "inscripcion",
            //                             "fecha_vigencia_aplicacion": "2022-08-12"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "cargo",
            //                             "codigo_detalle": "COLEGIATURA AGOSTO",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-08-31"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "cargo",
            //                             "codigo_detalle": "COLEGIATURA SEPTIEMBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-09-12"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "cargo",
            //                             "codigo_detalle": "COLEGIATURA OCTUBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-10-12"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "cargo",
            //                             "codigo_detalle": "COLEGIATURA NOVIEMBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-11-14"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "cargo",
            //                             "codigo_detalle": "COLEGIATURA DICIEMBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-12-13"
            //                         }
            //                         ],
            //                         "pagos": [
            //                         {
            //                             "monto": 7000,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO DE INSCRIPCIÓN",
            //                             "categoria": "inscripcion",
            //                             "fecha_vigencia_aplicacion": "2022-06-24"
            //                         },
            //                         {
            //                             "monto": 6330,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO DE INSCRIPCIÓN",
            //                             "categoria": "inscripcion",
            //                             "fecha_vigencia_aplicacion": "2022-07-01"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO COLEGIATURA SEPTIEMBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-10-05"
            //                         },
            //                         {
            //                             "monto": 8600,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO COLEGIATURA AGOSTO",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-10-05"
            //                         },
            //                         {
            //                             "monto": 8080,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO COLEGIATURA OCTUBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-10-12"
            //                         },
            //                         {
            //                             "monto": 8080,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO COLEGIATURA NOVIEMBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-11-11"
            //                         },
            //                         {
            //                             "monto": 8080,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "PAGO COLEGIATURA DICIEMBRE",
            //                             "categoria": "colegiatura",
            //                             "fecha_vigencia_aplicacion": "2022-12-08"
            //                         }
            //                         ],
            //                         "becas": [],
            //                         "descuentos": [
            //                         {
            //                             "monto": 1020,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "DESCUENTO INSCRIPCIÓN",
            //                             "categoria": "rebaja",
            //                             "fecha_vigencia_aplicacion": "2022-07-01"
            //                         },
            //                         {
            //                             "monto": 520,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "DESCUENTO OCTUBRE",
            //                             "categoria": "rebaja",
            //                             "fecha_vigencia_aplicacion": "2022-10-12"
            //                         },
            //                         {
            //                             "monto": 520,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "DESCUENTO NOVIEMBRE",
            //                             "categoria": "rebaja",
            //                             "fecha_vigencia_aplicacion": "2022-11-11"
            //                         },
            //                         {
            //                             "monto": 520,
            //                             "saldo_movimiento": 0,
            //                             "tipo": "abono",
            //                             "codigo_detalle": "DESCUENTO DICIEMBRE",
            //                             "categoria": "rebaja",
            //                             "fecha_vigencia_aplicacion": "2022-12-08"
            //                         }
            //                         ]
            //                     },]
            //             },
            //         ]
            //     }
            // ]
                    loading.close()
                    }else{
                        this.getExcel(params, '/indicadores/becas_y_descuentos_detalle')
                    }
                }else{
                    if(info == 'online'){
                    this.detalle = []
                    this.global = []
                    const loading = this.$vs.loading()
                    const {data: response} = await indicadores.getBecasDescuentosGlobal(params)
                    this.global = [response]
                    loading.close()
                    }else{
                        this.getExcel(params, '/indicadores/becas_y_descuentos_global')
                    }
                }
            }
        },
        getEliminarNameKey(info){
            const datos = Object.values(info)
            return datos
        },
        getExcel(formData, url){
            this.loadingExcel = true
            setTimeout(() => {
                axios.get(url, {
                    responseType: 'blob',
                    params: {...formData},
                    // responseType: 'arraybuffer',
                }).then(response => {
                    this.loadingExcel = false
                    if (response.data instanceof Blob) {
                        const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = downloadUrl;
                        var filename = "";
                        const disposition = response.headers['content-disposition'];
                        if (disposition && disposition.indexOf('attachment') !== -1) {
                            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                            const matches = filenameRegex.exec(disposition);
                            if (matches != null && matches[1]) {
                                filename = matches[1].replace(/['"]/g, '');
                                link.setAttribute('download', filename)
                            }
                        }
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                    }else{
                        throw { message: 'formatError' }
                    }
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: 'bottom-right',
                        title: 'Éxito',
                        text: 'Descarga lista'
                    })
                    this.loadingExcel = false
                }).catch(e => {
                    this.loadingExcel = false
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: 'bottom-right',
                        title: 'Ocurrió un problema inesperado'
                    })
                });
            }, 500);
        },
        async getInstituciones(){
            try {
                this.loadingInstituto = true
                const response = await general.getInstituciones()
                this.instituciones = response.data
                this.institucionId = (new Date()).getTime()
                this.loadingInstituto = false
            }
            catch(error){
                this.loadingInstituto = false
                console.log(error)
            }
        },
        async getCiclosEscolares(){
            if(this.institucion){
                try {
                    this.loadingCicloEscolar = true
                    const response = await general.getCiclosEscolares(this.institucion)
                    this.cicloEscolares = response.data
                    this.cicloEscolarId = (new Date()).getTime()
                    this.loadingCicloEscolar = false
                }
                catch(error){
                    this.loadingCicloEscolar = false
                    console.log(error)
                }
            }
        },
        async getPrograma() {
            if(this.institucion){
                this.programa = ''
                this.loadingPrograma = true
                const { data: response } = await general.getPrograma(this.institucion)
                this.programas = response
                this.programaId = (new Date()).getTime()
                this.loadingPrograma = false
            }
        },
    },
    watch:{
        institucion(){
           this.getCiclosEscolares()
           this.getPrograma()
        },
        detalle(){
            this.getCompartirInfo()
        }
    }
}
</script>
<style lang="scss" scoped>
    .tache{
        position: absolute;
        cursor: pointer;
        top: 35px;
        @media only screen and (max-width: 768px) {
            left: calc(95% - 4em);
        }
        @media only screen and (min-width: 768px) {
            left: calc(98% - 4em);
        }

    }
</style>